<template>
  <div>
    <BaseSmallSpinner v-if="loading"></BaseSmallSpinner>
    <table class="default-table text-center my-6" v-else>
      <thead>
        <th>ID</th>
        <th>Infoauto ID</th>
        <th>Infoauto Name</th>
        <th>Local Code</th>
        <th>Local Display</th>
      </thead>
      <tbody>
        <tr v-for="paymentType in paymentsTypes" :key="paymentType.id">
          <td>{{ paymentType.id }}</td>
          <td>{{ paymentType.infoautoId }}</td>
          <td>{{ paymentType.infoautoName }}</td>
          <td>{{ paymentType.localCode }}</td>
          <td>{{ paymentType.localDisplay }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { getPaymentsTypes } from "@/api/Infoauto.js";
export default {
  name: "PaymentsTypes",
  data() {
    return {
      paymentsTypes: [],
      loading: true
    };
  },
  async mounted() {
    this.paymentsTypes = await getPaymentsTypes();
    this.loading = false;
  }
};
</script>
